module.exports = " .center {text-align: center; margin-left: auto; margin-right: auto; margin-bottom: auto; margin-top: auto;}"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/errors/error404/error404.component.css
// module id = ./src/app/shared/errors/error404/error404.component.css
// module chunks = main